import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import privilegeListModel from '@/models/privilege/privilege-list'
import router from '@/router'
import store from '@/store'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import {
  onBeforeMount, reactive, ref, watch,
} from '@vue/composition-api'
import useInventoryManageCustom from './useInventoryManageCustom'

export default function useAddPrivilegeInventoryModal() {
  const {
    resolveStatusClass,
    resolveStatusLabel,
  } = useInventoryManageCustom()
  const { fetchPrivilegeListModel } = privilegeListModel()
  const { pagination, onPageChange } = usePagination()
  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable()
  const { openDefaultErrorModal, openErrorModal } = useValidationModal()

  const loading = reactive({
    tableData: false,
    tableOverlay: false,
  })

  const inventoryId = ref(0)

  const privilegeList = reactive({
    payload: [],
  })

  const statusOption = ref([
    { label: 'Active', value: 1 },
    { label: 'Inactive', value: 2 },
  ])

  const fields = [
    { key: 'seq', label: 'No.' },
    { key: 'alt_reference', label: 'Reference' },
    { key: 'image_url', label: 'Image/Banner' },
    { key: 'nameEn', label: 'Name' },
    { key: 'privilege_type', label: 'Reward Type' },
    { key: 'status', label: 'status' },
    { key: 'actions', label: '' },
  ]

  const onModalOpen = () => {
    // ToDo
  }

  const resolveEnableAddPrivilege = privilege => {
    if (privilege.inventory_entry) {
      return (
        privilege.inventory_entry.filter(elem => elem == inventoryId.value)
          .length > 0
      )
    }
    return false
  }

  const fetchPrivilegeList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true
    }
    fetchPrivilegeListModel.payload.Page = pagination.currentPage
    fetchPrivilegeListModel.payload.Limit = pagination.perPage
    fetchPrivilegeListModel.payload.Filters = filters
    fetchPrivilegeListModel.payload.Ordering = ordering.value
    store
      .dispatch('api/apiRequest', fetchPrivilegeListModel)
      .then(response => {
        privilegeList.payload = response.data.payload
        pagination.rows = response.data.payload.length
        pagination.totalRows = response.data.filtered_record
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
        loading.tableOverlay = false
      })
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchPrivilegeList()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchPrivilegeList()
    },
    { deep: true },
  )

  onBeforeMount(() => {
    inventoryId.value = router.currentRoute.params.ref
    fetchPrivilegeList()
  })

  return {
    fields,
    loading,
    privilegeList,
    onModalOpen,
    resolveStatusClass,
    resolveStatusLabel,
    pagination,
    onPageChange,
    onSetValueSearch,
    onSelectFilter,
    resolveEnableAddPrivilege,
    statusOption,
  }
}
